import { getUserInfoAPI } from "@/api/auth";
import type { Owner } from "@/api/auth.type";
import { STORAGE_KEYS } from "@/lib/constants";
import { create } from "zustand";

type UserStore = {
  user: Owner | null;
  setUser: (user: Owner | null) => void;
  refreshUser: () => Promise<boolean>;
  logout: () => void;
};

export const useUserStore = create<UserStore>((set) => ({
  user: null,
  setUser: (user) => set({ user }),
  refreshUser: async () => {
    try {
      const user = await getUserInfoAPI().then((res) => res.data.userInfo);
      if (user) {
        set({ user });
        return true;
      } else return false;
    } catch (error) {
      return false;
    }
  },
  logout: () => {
    localStorage.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
    set({ user: null });
  },
}));
